import React from "react";
import { Card, Input, Label, Table, Button } from "reactstrap";

const AuditLogCardSkeleton: React.FC = () => {
	return (
		<Card className="shadow p-4 mb-4 border-0 rounded">

			{/* Header */}
			<div className="mb-4 d-flex flex-column flex-lg-row justify-content-between align-items-start align-items-lg-center gap-4 bg-light px-3 py-3">
				{/* Staff Info */}
				<div className="p-3 rounded border bg-light placeholder-glow" style={{ minWidth: "220px" }}>
					<div className="placeholder col-8 mb-2"></div> {/* Staff Name */}
					<div className="d-flex align-items-center gap-2 mb-1">
						<i className="ri-time-line text-muted" />
						<div className="placeholder col-6"></div>
					</div>
					<div className="d-flex align-items-center gap-2 mb-1">
						<i className="ri-login-box-line text-muted" />
						<div className="placeholder col-6"></div>
					</div>
					<div className="d-flex align-items-center gap-2">
						<i className="ri-logout-box-line text-muted" />
						<div className="placeholder col-6"></div>
					</div>
				</div>

				{/* Summary */}
				<div className="d-flex flex-wrap justify-content-center align-items-center gap-3 flex-grow-1">
					{[1, 2, 3].map((i) => (
						<div
							key={i}
							className="text-center bg-white border rounded p-3 px-4 placeholder-glow"
							style={{ minWidth: 140, maxWidth: 160 }}
						>
							<div className="placeholder col-12 mb-1" style={{ height: "0.875rem" }} /> {/* Label: small */}
							<div className="placeholder col-6 mb-2" style={{ height: "1.75rem" }} />   {/* Main Value: fs-4 */}
							<div className="placeholder col-12" style={{ height: "0.75rem" }} />       {/* / team: small */}
						</div>
					))}
				</div>



				<div className="placeholder-glow mt-3 mt-lg-0" style={{ width: 200 }}>
					<Label className="fw-semibold d-block mb-2 text-end">Footprint Date</Label>
					<div className="form-control ps-5 pe-3 py-2 position-relative rounded">
						<span className="placeholder col-6"></span>
						<i className="ri-calendar-2-line position-absolute top-50 start-0 translate-middle-y ps-3 text-primary" />
					</div>
				</div>
			</div>

			{/* Filters */}
			<div className="mb-4 bg-light px-3 py-3">
				<div className="d-flex justify-content-start align-items-center mb-2 gap-2">
					<h5 className="fw-semibold mb-0">Filters</h5>
					<Button color="danger" className="btn-label btn-sm disabled placeholder col-2" disabled />
				</div>
				<div className="row g-3">
					{[1, 2, 3, 4].map((i) => (
						<div key={i} className="col-md-3 placeholder-glow">
							<Label className="form-label text-muted small mb-1">Loading...</Label>
							<div className="form-control placeholder col-12 py-2"></div>
						</div>
					))}
				</div>
			</div>

			{/* Remarks */}
			<div className="mb-4">
				<h5 className="fw-semibold">Remarks</h5>
				<div className="d-flex flex-column gap-2">
					{[1, 2].map((i) => (
						<div key={i} className="d-flex align-items-center gap-2 placeholder-glow">
							<i className="ri-alert-fill fs-5 text-warning" />
							<span className="placeholder col-6"></span>
						</div>
					))}
				</div>
			</div>

			{/* Activity Table */}
			<div className="mb-5 d-flex flex-column gap-1">
				<h5 className="fw-semibold">Activities</h5>
				<Table className="align-middle table-nowrap mb-0 table-bordered rounded">
					<thead className="table-light">
						<tr>
							<th style={{ width: "12%" }}>Timestamp</th>
							<th style={{ width: "15%" }}>Lead Name</th>
							<th style={{ width: "10%" }}>Type</th>
							<th style={{ width: "10%" }}>Action</th>
							<th style={{ width: "12%" }}>Time Spent</th>
							<th style={{ width: "25%" }}>Details</th>
							<th style={{ width: "8%" }}>Points</th>
							<th style={{ width: "8%" }}>Gap</th>
						</tr>
					</thead>
					<tbody>
						{[1, 2].map((hourBlock) => (
							<React.Fragment key={hourBlock}>
								{/* Block Header Row */}
								<tr className="bg-light fw-semibold text-dark">
									<td colSpan={8}>
										<div className="d-flex justify-content-between align-items-center placeholder-glow">
											<div className="placeholder col-3"></div>
											<div className="placeholder col-3"></div>
											<div className="placeholder col-1"></div>
										</div>
									</td>
								</tr>
								{/* 3 Placeholder Rows */}
								{[1, 2, 3].map((log) => (
									<tr key={log} className="placeholder-glow">
										{[...Array(8)].map((_, idx) => (
											<td key={idx}><span className="placeholder col-8"></span></td>
										))}
									</tr>
								))}
							</React.Fragment>
						))}
					</tbody>
				</Table>
			</div>
		</Card>
	);
};

export default AuditLogCardSkeleton;
